import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/camera-add-photo.svg'


const _withScopeId = n => (_pushScopeId("data-v-6cf91f20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fb-container body" }
const _hoisted_2 = { class: "fb-form" }
const _hoisted_3 = { class: "fb-form-heading" }
const _hoisted_4 = { class: "fb-form-subheading" }
const _hoisted_5 = { class: "photo-capture-section" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Camera",
  class: "photo-icon"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "photo-button-text" }, "Take a photo", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "photo-preview-container"
}
const _hoisted_10 = {
  ref: "photoCanvas",
  class: "photo-preview"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-trash-can" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "mx-auto fb-form-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fbx_textarea = _resolveComponent("fbx-textarea")!
  const _component_fbx_button = _resolveComponent("fbx-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.title), 1),
        _createElementVNode("div", _hoisted_4, "(" + _toDisplayString(_ctx.subTitle) + ")", 1),
        _createElementVNode("div", _hoisted_5, [
          (!_ctx.photoTaken)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "take-photo-button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onTakePicture && _ctx.onTakePicture(...args)))
              }, _hoisted_8))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("canvas", _hoisted_10, null, 512),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn delete-photo-button",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDeletePhoto && _ctx.onDeletePhoto(...args))),
                  "aria-label": "Delete photo"
                }, _hoisted_12)
              ])),
          _createElementVNode("input", {
            ref: "imageInput",
            type: "file",
            accept: "image/jpeg,image/png",
            capture: "environment",
            style: {"display":"none"},
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onImageUploaded && _ctx.onImageUploaded(...args)))
          }, null, 544)
        ]),
        _createVNode(_component_fbx_textarea, {
          class: "fb-textarea",
          modelValue: _ctx.textareaModel,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.textareaModel) = $event)),
          maxlength: 140,
          model: _ctx.textareaModel,
          placeholder: "Record any concerns or damage..."
        }, null, 8, ["modelValue", "model"]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_fbx_button, {
            buttonText: "Cancel",
            class: "wide cancel",
            onClick: _ctx.onCancel,
            theme: "primaryOutline"
          }, null, 8, ["onClick"]),
          _createVNode(_component_fbx_button, {
            buttonText: "Save",
            class: "wide",
            onClick: _ctx.onSave,
            theme: "primary",
            disabled: _ctx.isSaveDisabled
          }, null, 8, ["onClick", "disabled"])
        ])
      ])
    ])
  ]))
}